<template>
    <a-layout style="min-height: 100vh;">
        <UserHead />
        <a-layout>
            <a-layout-header style="padding: 0; background: #fff; border-bottom: 1px solid #f0f0f0;">
                <HeadTop />
            </a-layout-header>
            <a-layout-content class="page-content" style="padding: 24px; background: #f5f7fa;">
                <div class="page-inner">
                    <!-- 顶部统计卡片 -->
                    <a-row :gutter="[16, 16]" class="stat-row">
                        <a-col :xs="24" :sm="12" :md="8">
                            <a-card class="stat-card" :bordered="false">
                                <div class="stat-inner">
                                    <div class="stat-icon stat-icon-blue">
                                        <ApiOutlined />
                                    </div>
                                    <div class="stat-info">
                                        <div class="stat-label">AppId</div>
                                        <div class="stat-value stat-value-sm stat-ellipsis" :title="dock_data.AppId">
                                            {{ dock_data.AppId || '--' }}
                                        </div>
                                    </div>
                                </div>
                            </a-card>
                        </a-col>
                        <a-col :xs="24" :sm="12" :md="8">
                            <a-card class="stat-card" :bordered="false">
                                <div class="stat-inner">
                                    <div class="stat-icon stat-icon-green">
                                        <KeyOutlined />
                                    </div>
                                    <div class="stat-info">
                                        <div class="stat-label">接口密钥</div>
                                        <div class="stat-value stat-value-sm stat-ellipsis" :title="dock_data.dock_key">
                                            {{ dock_data.dock_key ? dock_data.dock_key.substring(0, 8) + '****' : '--'
                                            }}
                                        </div>
                                    </div>
                                </div>
                            </a-card>
                        </a-col>
                        <a-col :xs="24" :sm="12" :md="8">
                            <a-card class="stat-card" :bordered="false">
                                <div class="stat-inner">
                                    <div class="stat-icon stat-icon-orange">
                                        <UserOutlined />
                                    </div>
                                    <div class="stat-info">
                                        <div class="stat-label">用户编号</div>
                                        <div class="stat-value stat-value-sm">{{ dock_data.uid || '--' }}</div>
                                    </div>
                                </div>
                            </a-card>
                        </a-col>
                    </a-row>

                    <!-- 密钥管理卡片 -->
                    <a-card :bordered="false" class="table-card">
                        <template #title>
                            <div class="card-title-row">
                                <span class="card-title-text">API 密钥管理</span>
                                <a-tag color="gold">亿乐接口兼容</a-tag>
                                <a-tag color="gold">无需白名单</a-tag>
                                <a-tag color="gold">首次使用请重置</a-tag>
                            </div>
                        </template>

                        <a-form layout="horizontal" :label-col="{ span: 3 }" :wrapper-col="{ span: 16 }"
                            class="key-form">
                            <a-form-item label="AppId">
                                <a-input :value="dock_data.AppId" disabled style="max-width: 360px;">
                                    <template #addonAfter>
                                        <a-button type="link" size="small" style="padding: 0;"
                                            @click="copyFun1(dock_data.AppId)">
                                            <template #icon>
                                                <CopyOutlined />
                                            </template>复制
                                        </a-button>
                                    </template>
                                </a-input>
                            </a-form-item>
                            <a-form-item label="密钥">
                                <a-input :value="dock_data.dock_key" disabled style="max-width: 360px;"
                                    @click="copyFun1(dock_data.dock_key)">
                                    <template #addonAfter>
                                        <a-button type="link" size="small" style="padding: 0;"
                                            @click="copyFun1(dock_data.dock_key)">
                                            <template #icon>
                                                <CopyOutlined />
                                            </template>复制
                                        </a-button>
                                    </template>
                                </a-input>
                            </a-form-item>
                            <a-form-item :wrapper-col="{ offset: 3, span: 16 }">
                                <a-button type="primary" @click="setDockKey">
                                    <template #icon>
                                        <ReloadOutlined />
                                    </template>重置密钥
                                </a-button>
                                <a-button style="margin-left: 8px;" @click="copyFun1(dock_data.dock_url)"
                                    :disabled="!dock_data.dock_url">
                                    <template #icon>
                                        <CopyOutlined />
                                    </template>复制完整 URL
                                </a-button>
                            </a-form-item>
                        </a-form>
                    </a-card>

                    <!-- 对接参数说明 -->
                    <a-card :bordered="false" class="table-card">
                        <template #title>
                            <div class="card-title-row">
                                <span class="card-title-text">接口参数说明</span>
                                <a-tag color="blue">{{ parameter_data.length }} 项</a-tag>
                            </div>
                        </template>

                        <!-- PC 端表格 -->
                        <a-table class="param-table-pc" :data-source="parameter_data" :pagination="false" row-key="name"
                            :scroll="{ x: 800 }" size="small" :loading="paramLoading" bordered :columns="paramColumns">
                            <template #bodyCell="{ column, record }">
                                <!-- 参数名 -->
                                <template v-if="column.key === 'name'">
                                    <a-tag color="blue" style="margin: 0; font-family: monospace;">{{ record.name
                                        }}</a-tag>
                                </template>
                                <!-- 示例 -->
                                <template v-else-if="column.key === 'example'">
                                    <code class="param-example">{{ record.example }}</code>
                                </template>
                                <!-- 是否必填 -->
                                <template v-else-if="column.key === 'notNull'">
                                    <a-tag v-if="record.notNull" color="red" style="margin: 0;">必填</a-tag>
                                    <a-tag v-else color="default" style="margin: 0;">选填</a-tag>
                                </template>
                            </template>
                        </a-table>

                        <!-- 手机端卡片列表 -->
                        <div class="param-card-list" v-if="parameter_data && parameter_data.length > 0">
                            <a-card v-for="record in parameter_data" :key="record.name" class="param-mobile-card"
                                :bordered="false">
                                <div class="mobile-card-head">
                                    <div class="mobile-card-title">
                                        <a-tag color="blue" style="margin: 0; font-family: monospace;">{{ record.name
                                            }}</a-tag>
                                        <a-tag v-if="record.notNull" color="red">必填</a-tag>
                                        <a-tag v-else color="default">选填</a-tag>
                                    </div>
                                </div>
                                <div class="mobile-card-body">
                                    <div class="mobile-field">
                                        <span class="mobile-label">示例</span>
                                        <code class="param-example">{{ record.example }}</code>
                                    </div>
                                    <div class="mobile-field">
                                        <span class="mobile-label">说明</span>
                                        <span class="mobile-value">{{ record.desc }}</span>
                                    </div>
                                </div>
                            </a-card>
                        </div>

                        <a-empty v-if="(!parameter_data || parameter_data.length === 0) && !paramLoading"
                            description="暂无参数数据" />
                    </a-card>

                    <!-- API 对接文档 -->
                    <a-card :bordered="false" class="table-card">
                        <template #title>
                            <div class="card-title-row">
                                <span class="card-title-text">API 对接文档</span>
                            </div>
                        </template>

                        <router-link to="/apiDoc" class="docs-link">
                            <LinkOutlined />
                            查看完整接口文档
                        </router-link>

                        <a-row :gutter="[16, 16]" class="feature-row">
                            <a-col :xs="24" :sm="12" :md="6">
                                <div class="feature-item">
                                    <div class="feature-icon feature-icon-blue">
                                        <UnorderedListOutlined />
                                    </div>
                                    <div class="feature-title">分类列表接口</div>
                                    <div class="feature-desc">支持查询所有软件分类信息</div>
                                </div>
                            </a-col>
                            <a-col :xs="24" :sm="12" :md="6">
                                <div class="feature-item">
                                    <div class="feature-icon feature-icon-green">
                                        <AppstoreOutlined />
                                    </div>
                                    <div class="feature-title">授权商品列表</div>
                                    <div class="feature-desc">支持根据分类ID查询相关商品</div>
                                </div>
                            </a-col>
                            <a-col :xs="24" :sm="12" :md="6">
                                <div class="feature-item">
                                    <div class="feature-icon feature-icon-orange">
                                        <FileSearchOutlined />
                                    </div>
                                    <div class="feature-title">商品详情接口</div>
                                    <div class="feature-desc">支持根据商品ID查询详细信息</div>
                                </div>
                            </a-col>
                            <a-col :xs="24" :sm="12" :md="6">
                                <div class="feature-item">
                                    <div class="feature-icon feature-icon-purple">
                                        <UserOutlined />
                                    </div>
                                    <div class="feature-title">用户信息查询</div>
                                    <div class="feature-desc">支持查询用户昵称、余额等信息</div>
                                </div>
                            </a-col>
                        </a-row>
                    </a-card>
                </div>
            </a-layout-content>
        </a-layout>
    </a-layout>
</template>

<script>
import { defineComponent } from 'vue';
import UserHead from '@/components/UserHead.vue';
import HeadTop from '@/components/UserHeadTop.vue';
import { message, Modal } from 'ant-design-vue';
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils';
import { copyFun, getEmpowerIncludesList } from '@/utils/publicMethods';
import {
    LinkOutlined,
    ApiOutlined,
    KeyOutlined,
    CopyOutlined,
    ReloadOutlined,
    UnorderedListOutlined,
    AppstoreOutlined,
    FileSearchOutlined,
    UserOutlined,
} from '@ant-design/icons-vue';
import axios from 'axios';
const baseURL = process.env.VUE_APP_API_BASE_URL;

export default defineComponent({
    components: {
        UserHead,
        HeadTop,
        LinkOutlined,
        ApiOutlined,
        KeyOutlined,
        CopyOutlined,
        ReloadOutlined,
        UnorderedListOutlined,
        AppstoreOutlined,
        FileSearchOutlined,
        UserOutlined,
    },
    data() {
        return {
            dock_data: {
                uid: '',
                dock_key: '',
                AppId: '',
                dock_url: '',
                dock_url2: '',
            },
            time_meal_data: {
                select_option: '',
                time_meal_list: [],
                num: 1,
                meal_id: 0,
                min: 1,
                max: 1,
                unit: '',
                price: 1,
            },
            includes_data: {
                select_option: '',
                includes_list: [],
            },
            empowerApi: {
                host: '',
                user_email: '',
            },
            parameter_data: [
                { name: 'uid', example: '1000', desc: '用户编号', notNull: true },
                { name: 'key', example: 'wred254sfu44d5g1w3t', desc: '接口密钥', notNull: true },
                { name: 'includes_id', example: '1', desc: '授权插件id', notNull: true },
                { name: 'time_act', example: '1', desc: '时长类型，1表示天，2表示月，3表示年，4表示永久', notNull: true },
                { name: 'time_num', example: '10', desc: '时长份数，比如当时长类型为天时，这里的时长份数填10就是表示10天', notNull: true },
                { name: 'email', example: '123456@qq.com', desc: '被授权者的邮箱，会自动注册为你的下级，若是别人的下级则不会变化', notNull: true },
                { name: 'host', example: 'ljwx.site', desc: '被授权者的域名，格式例如：www.baidu.com，不可带http和斜杠/，并且请注意相关插件要求填写一级域名还是后台登录域名', notNull: true },
            ],
            paramLoading: false,
            apiDocs: '',
            paramColumns: [
                { title: '参数名', key: 'name', width: 140 },
                { title: '示例', key: 'example', width: 220 },
                { title: '说明', dataIndex: 'desc', key: 'desc', ellipsis: true },
                { title: '必填', key: 'notNull', width: 80, align: 'center' },
            ],
        };
    },
    methods: {
        async getDockKey() {
            openLoading();
            this.paramLoading = true;
            try {
                const res_data = await getEmpowerIncludesList(999, 1);
                this.includes_data.includes_list = res_data.data;
            } catch (e) {
                // ignore
            }
            const data = new FormData();
            data.append('act', 'getDockKey');
            const headers = {
                token: localStorage.getItem('token'),
            };
            axios
                .post(baseURL + '/userApi/getInfo', data, { timeout: 30000, headers })
                .then((res) => {
                    if (res.data.code == 200) {
                        this.dock_data = res.data.data;
                        this.dock_data.dock_url =
                            window.location.host +
                            '/userApi/empowerByApi?uid=' +
                            this.dock_data.uid +
                            '&key=' +
                            this.dock_data.dock_key +
                            '&includes_id=[插件id]&time_act=[时长类型]&time_num=[份数]&email=[被授权者邮箱]&host=[被授权的域名]';
                        this.apiDocs = res.data.data.dock_url;
                        return;
                    } else {
                        message.error(res.data.msg);
                    }
                    if (res.data.code == 401) {
                        message.error(res.data.msg);
                        setTimeout(() => {
                            location.href = '/Login';
                        }, 1000);
                    }
                })
                .catch((err) => {
                    message.error(err);
                })
                .finally(() => {
                    fullscreenLoading.close();
                    this.paramLoading = false;
                });
        },
        generateKey() {
            const uid = this.dock_data.uid;
            const includes_id = this.includes_data.select_option;
            const meal_id = this.time_meal_data.select_option;
            if (includes_id == '' || meal_id == '') {
                message.error('请选中插件和插件时长类型');
                return;
            }
            const key = this.dock_data.dock_key;
            if (key == '') {
                message.error('请先刷新密钥');
                return;
            }
            this.dock_data.dock_url2 =
                window.location.host +
                '/userApi/empowerByApi?uid=' +
                uid +
                '&key=' +
                key +
                '&includes_id=' +
                includes_id +
                '&time_act=' +
                meal_id +
                '&time_num=[份数]' +
                '&email=[被授权者邮箱]' +
                '&host=[被授权的域名]';
            message.success('快捷生成URL成功');
        },
        setDockKey() {
            Modal.confirm({
                title: '确认重置',
                content: '是否重置秘钥?之前的密钥将会失效',
                okText: '确认',
                cancelText: '取消',
                onOk: () => {
                    openLoading();
                    const data = new FormData();
                    data.append('act', 'setDockKey');
                    const headers = {
                        token: localStorage.getItem('token'),
                    };
                    axios
                        .post(baseURL + '/userApi/getInfo', data, { timeout: 30000, headers })
                        .then((res) => {
                            if (res.data.code == 200) {
                                this.dock_data = res.data.data;
                                this.dock_data.dock_url =
                                    window.location.host +
                                    '/userApi/empowerByApi?uid=' +
                                    this.dock_data.uid +
                                    '&key=' +
                                    this.dock_data.dock_key +
                                    '&includes_id=[插件id]&time_act=[时长类型]&time_num=[份数]&email=[被授权者邮箱]&host=[被授权的域名]';
                                this.apiDocs = res.data.data.dock_url;
                                return;
                            } else {
                                message.error(res.data.msg);
                            }
                            if (res.data.code == 401) {
                                message.error(res.data.msg);
                                setTimeout(() => {
                                    location.href = '/Login';
                                }, 1000);
                            }
                        })
                        .catch((err) => {
                            message.error(err);
                        })
                        .finally(() => {
                            fullscreenLoading.close();
                        });
                },
                onCancel: () => undefined,
            });
        },
        getTimeMeal(includes_id) {
            openLoading();
            this.time_meal_data.select_option = '';
            const data = new FormData();
            const headers = {
                token: localStorage.getItem('token'),
            };
            data.append('includes_id', includes_id);
            data.append('act', 'getTimeMeal');
            axios
                .post(baseURL + '/userApi/getInfo', data, { timeout: 30000, headers })
                .then((res) => {
                    fullscreenLoading.close();
                    if (res.data.code == 401) {
                        message.error(res.data.msg);
                        setTimeout(() => {
                            location.href = '/Login';
                        }, 1000);
                    } else if (res.data.code == 200) {
                        this.time_meal_data.time_meal_list = res.data.data;
                    } else {
                        message.error(res.data.msg);
                    }
                })
                .catch((err) => {
                    fullscreenLoading.close();
                    console.log(err);
                    message.error('请求失败：' + err.message);
                });
        },
        copyFun1(text) {
            if (!text) {
                message.warning('内容为空，无法复制');
                return;
            }
            copyFun(text);
        },
    },
    mounted() {
        this.getDockKey();
    },
});
</script>

<style lang="scss">
/* ===== Page Layout ===== */
.page-inner {
    max-width: 1200px;
    margin: 0 auto;
}

/* ===== Stat Cards ===== */
.stat-row {
    margin-bottom: 12px;
}

.stat-card {
    border-radius: 8px;
    transition: all 0.3s ease;

    &:hover {
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
        transform: translateY(-2px);
    }

    :deep(.ant-card-body) {
        padding: 16px 20px;
    }
}

.stat-inner {
    display: flex;
    align-items: center;
    gap: 14px;
}

.stat-icon {
    width: 44px;
    height: 44px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    flex-shrink: 0;

    &.stat-icon-blue {
        background: linear-gradient(135deg, #e6f4ff, #bae0ff);
        color: #1677ff;
    }

    &.stat-icon-green {
        background: linear-gradient(135deg, #f6ffed, #d9f7be);
        color: #52c41a;
    }

    &.stat-icon-orange {
        background: linear-gradient(135deg, #fff7e6, #ffd591);
        color: #fa8c16;
    }

    &.stat-icon-purple {
        background: linear-gradient(135deg, #f9f0ff, #d3adf7);
        color: #722ed1;
    }
}

.stat-info {
    flex: 1;
    min-width: 0;
}

.stat-label {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.45);
    margin-bottom: 2px;
}

.stat-value {
    font-size: 22px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.88);
    line-height: 1.2;

    &.stat-value-sm {
        font-size: 18px;
    }
}

.stat-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* ===== Table Card ===== */
.table-card {
    border-radius: 8px;
    margin-bottom: 12px;

    :deep(.ant-card-head) {
        border-bottom: 1px solid #f0f0f0;
        padding: 0 16px;
        min-height: 48px;
    }

    :deep(.ant-card-body) {
        padding: 16px;
    }
}

.card-title-row {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.card-title-text {
    font-weight: 600;
    font-size: 14px;
}

/* ===== Key Form ===== */
.key-form {
    margin-top: 8px;

    :deep(.ant-form-item) {
        margin-bottom: 14px;
    }

    :deep(.ant-form-item-label > label) {
        font-weight: 500;
        color: #374151;
        font-size: 13px;
    }
}

/* ===== Params Table ===== */
.param-example {
    background: #f5f5f5;
    padding: 1px 6px;
    border-radius: 4px;
    font-size: 12px;
    color: #d63384;
    font-family: 'Consolas', 'Monaco', monospace;
}

.table-card :deep(.ant-table) {
    .ant-table-thead>tr>th {
        padding: 8px 10px !important;
        font-size: 12px;
        background: #fafafa;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.65);
        white-space: nowrap;
    }

    .ant-table-tbody>tr>td {
        padding: 8px 10px !important;
        font-size: 13px;
    }

    .ant-table-cell {
        padding: 8px 10px !important;
    }
}

/* ===== Docs Link ===== */
.docs-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #1677ff;
    text-decoration: none;
    font-size: 13px;
    margin-bottom: 16px;
    padding: 8px 14px;
    background: #f0f5ff;
    border-radius: 8px;
    border: 1px solid #adc6ff;
    transition: all 0.2s ease;

    &:hover {
        background: #e6f4ff;
        border-color: #91caff;
        color: #0958d9;
    }
}

/* ===== Feature Grid ===== */
.feature-row {
    margin-top: 4px;
}

.feature-item {
    background: #fafafa;
    padding: 16px;
    border-radius: 10px;
    border: 1px solid #f0f0f0;
    transition: all 0.2s ease;
    height: 100%;

    &:hover {
        border-color: #d9d9d9;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
        transform: translateY(-2px);
    }
}

.feature-icon {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    margin-bottom: 10px;

    &.feature-icon-blue {
        background: linear-gradient(135deg, #e6f4ff, #bae0ff);
        color: #1677ff;
    }

    &.feature-icon-green {
        background: linear-gradient(135deg, #f6ffed, #d9f7be);
        color: #52c41a;
    }

    &.feature-icon-orange {
        background: linear-gradient(135deg, #fff7e6, #ffd591);
        color: #fa8c16;
    }

    &.feature-icon-purple {
        background: linear-gradient(135deg, #f9f0ff, #d3adf7);
        color: #722ed1;
    }
}

.feature-title {
    font-size: 13px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.88);
    margin-bottom: 4px;
}

.feature-desc {
    color: rgba(0, 0, 0, 0.55);
    font-size: 12px;
    line-height: 1.5;
}

/* ===== PC vs Mobile ===== */
.param-card-list {
    display: none;
    gap: 12px;

    .param-mobile-card {
        border-radius: 10px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);

        :deep(.ant-card-body) {
            padding: 12px 14px;
        }
    }

    .mobile-card-head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;
        padding-bottom: 8px;
        border-bottom: 1px solid #f0f0f0;
    }

    .mobile-card-title {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 13px;
        font-weight: 600;
    }

    .mobile-card-body {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .mobile-field {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        font-size: 13px;
        flex-wrap: wrap;
    }

    .mobile-label {
        color: rgba(0, 0, 0, 0.45);
        min-width: 48px;
        flex-shrink: 0;
        font-size: 12px;
    }

    .mobile-value {
        flex: 1;
        color: rgba(0, 0, 0, 0.88);
        font-size: 12px;
        line-height: 1.5;
        word-break: break-all;
    }
}

/* ===== Mobile Responsive @ 768px ===== */
@media screen and (max-width: 768px) {
    .param-table-pc {
        display: none !important;
    }

    .param-card-list {
        display: flex !important;
        flex-direction: column;
    }

    .table-card {
        margin-bottom: 8px;

        :deep(.ant-card-head) {
            padding: 0 12px;
            min-height: 44px;
        }

        :deep(.ant-card-body) {
            padding: 12px;
        }
    }

    .stat-row {
        margin-bottom: 8px;
    }

    .stat-card :deep(.ant-card-body) {
        padding: 12px 14px;
    }

    .stat-inner {
        gap: 10px;
    }

    .stat-icon {
        width: 36px;
        height: 36px;
        font-size: 16px;
        border-radius: 8px;
    }

    .stat-value {
        font-size: 18px;

        &.stat-value-sm {
            font-size: 15px;
        }
    }

    .card-title-row {
        gap: 6px;
        flex-wrap: wrap;
    }

    .card-title-text {
        font-size: 13px;
    }

    .key-form {
        :deep(.ant-form-item) {
            margin-bottom: 12px;
        }

        :deep(.ant-form-item-label) {
            padding-bottom: 2px;
        }
    }

    .docs-link {
        margin-bottom: 12px;
        padding: 6px 12px;
        font-size: 12px;
    }

    .feature-item {
        padding: 14px;
        margin-bottom: 8px;
    }
}

/* ===== Very small phones @ 480px ===== */
@media screen and (max-width: 480px) {
    .stat-icon {
        width: 32px;
        height: 32px;
        font-size: 14px;
    }

    .stat-value {
        font-size: 16px;

        &.stat-value-sm {
            font-size: 14px;
        }
    }

    .table-card :deep(.ant-card-body) {
        padding: 10px;
    }

    .key-form {
        :deep(.ant-form-item) {
            margin-bottom: 10px;
        }

        :deep(.ant-input-group-addon) {
            padding: 0 6px;
        }
    }
}
</style>
